import { combineReducers } from "@reduxjs/toolkit";

import contactDetailsSlice from "./slices/contact-details.slice";
import countryChangeModalSlice from "./slices/country-change.slice";
import apiErrorSlice from "./slices/errors/api-error.slice";
import helpOverlayReducer from "./slices/help-overlay.slice";
import medicalReducer from "./slices/medical.slice";
import paymentConsentsSlice from "./slices/payment-consents.slice";
import progressSlice from "./slices/progress.slice";
import QuoteSlice from "./slices/quote/quote.slice";
import withdrawalReducer from "./slices/withdrawal/withdrawal.slice";

const rootReducer = combineReducers({
  quote: QuoteSlice,
  medical: medicalReducer,
  progress: progressSlice,
  paymentConsents: paymentConsentsSlice,
  apiError: apiErrorSlice,
  contactDetails: contactDetailsSlice,
  countryChangeModal: countryChangeModalSlice,
  helpOverlay: helpOverlayReducer,
  withdrawal: withdrawalReducer,
});

export default rootReducer;

export type RootState = ReturnType<typeof rootReducer>;
